export const blockIconsSocialForestNew = (
	<span className='material-symbols-outlined'>forest</span>
);
